import type { FC } from 'react'

import type { StepComponentProps } from '../types'
import { StepMarkerComponent } from './StepMarkerComponent'
import { StepSegyComponent } from './StepSegyComponent'

export const StepComponent: FC<StepComponentProps> = props => {
  switch (props.file.uploadedFile?.entityType) {
    case 'marker': {
      return <StepMarkerComponent {...props} />
    }
    case 'segy': {
      return <StepSegyComponent {...props} />
    }
    case 'well': {
      // Это не опечатка, для визуализации скважин позаимствован визуализатор Segy
      // TODO сделать собственный визуализатор или общий с соответствующим названием, чтобы изменения в Segy не сплешевали по скважинам
      return <StepSegyComponent {...props} />
    }
    default:
      return null
  }
}
